'use strict';

angular.module('admin.language')

.controller('LanguageAdminCtrl', function ($scope, model, modelNameField)
{
    $scope.model = model;
    $scope.modelNameField = modelNameField;

    if ($scope.model.enabled === undefined){
        $scope.model.enabled = false;
    }

    $scope.saveModel = function ()
    {
        $scope.model.DSCreate(model, {upsert: true}).then($scope.$close);
    };
});
